import { request } from "@/utils/request";
/**
 * 查询会话组
 * @param {*} data 
 * @returns 
 */
export function selectApi(data) {
  return request({
    url: `/mobile/conversationGroup/select`,
    method: "POST",
    data,
  });
}

/* 创建会话组 */
export function addApi(data) {
  return request({
    url: `/mobile/conversationGroup/add`,
    method: "POST",
    data,
  });
}

/* 删除会话组 */
export function deleteApi(data) {
  return request({
    url: `/mobile/conversationGroup/delete`,
    method: "DELETE",
    data
  });
}

